<template>
  <div>
    <draggable
      v-model="key_records"
      filter=".ignore-elements"
      handle=".drag-handle"
      :component-data="{ type: 'transition-group', name: !drag ? 'flip-list' : null }"
      v-bind="dragOptions"
      item-key="name"
      class="border-light-divider-border dark:border-dark-divider-border w-[400px] text-left transition ease-in-out duration-side-menu-transition-duration"
      tag="tr"
      @start="drag = true"
      @end="drag = false">
      <template #item="{ element }">
        <div class="flex space-x-3 items-center group/tab bg-white rounded-md w-[450px]">
          <div class="flex space-x-2">
            <div class="drag-handle">
              <GripVertical
                class="w-4 h-4 -mt-1 duration-300 delay-300 opacity-0 group-hover/tab:opacity-100 group-hover/tab:cursor-pointer hover:text-red-400"
                color="#B3CAD6" />
            </div>
            <Trash2
              :class="[{ '!opacity-0': drag }, { 'duration-300 delay-300 o group-hover/tab': !drag }]"
              class="w-5 h-5 absolute duration-300 delay-300 opacity-0 group-hover/tab:opacity-100 group-hover/tab:cursor-pointer hover:text-red-400 right-6"
              @click="deleteKeyRecord(element)" />
          </div>
          <div class="flex space-x-2 w-full mt-4">
            <Avatar
              :radius="40"
              class="mt-1 mr-1"
              :hover-effect="true"
              :first-name="$utils.getRecordName(element)?.split(' ')[0]"
              :last-name="$utils.getRecordName(element)?.split(' ')[1]" />
            <div class="flex flex-col -space-y-1">
              <div class="text-lg font-medium flex">
                {{ $utils.getRecordName(element) }} <span @click="deleteKeyRecord(element)" />
              </div>
              <div class="text-md font-normal capitalize">
                {{ element.type }}
              </div>
              <div class="flex w-full dark:border-dark-divider-border rounded-lg h-full py-1">
                <div class="flex flex-grow w-full">
                  <div class="flex-1" />
                  <div class="flex justify-start w-full pl-0">
                    <span
                      v-for="i in 5"
                      :key="i"
                      @click.stop="
                        () => {
                          element.values.contact_relationship_strength = i
                          handleUpdateStarValue(i, element)
                        }
                      ">
                      <svg
                        class="block w-5 h-5 mr-2"
                        :class="[
                          element?.values?.contact_relationship_strength >= i
                            ? element?.values?.contact_relationship_strength >= 4
                              ? 'text-status-success-green'
                              : element?.values?.contact_relationship_strength >= 3
                                ? 'text-status-warning-yellow'
                                : 'text-status-error-red'
                            : 'text-gray-300'
                        ]"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20">
                        <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </draggable>

    <div class="flex w-full mt-4">
      <div :class="[]" class="inline-block px-2 mt-3 brand-blue text-center rounded-md cursor-pointer">
        <div>
          <div class="flex space-x-2 items-center">
            <ContactsSelect
              v-model:selected-contacts="selected_contacts"
              :add-new-user="true"
              :excluded-contacts="key_records.map((k_r) => k_r.id)"
              :label="$t('Add Key People')"
              :companies="[record]" />
            <button v-if="selected_contacts?.length" class="btn cancel-btn mt-8 py-1 px-2" @click="addKeyPeople">{{ $t("ADD") }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-row justify-end gap-2 mt-5 text-center">
      <button type="button" class="cancel-btn" @click="$emit('cancel')">{{ $t("Cancel") }}</button>
      <button type="button" class="primary-btn w-fit" @click="saveChanges">{{ $t("Save") }}</button>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import { Trash2, GripVertical } from "lucide-vue-next"
import ContactsSelect from "@/components/shared/ContactsSelect.vue"
import Avatar from "@/components/shared/Avatar.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { draggable, Trash2, ContactsSelect, Avatar, GripVertical },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  emits: ["cancel", "done"],

  data() {
    return {
      drag: false,
      key_records: [],
      add_new_key_record: false,
      selected_contacts: []
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "user header",
        disabled: false,
        ghostClass: "ghost",
        chosenClass: "chosen"
      }
    }
  },

  watch: {},
  created() {
    this.key_records = this.record.key_records
  },

  methods: {
    handleUpdateStarValue(i, key_record) {
      this.$store
        .dispatch("data/updateRecord", {
          record_id: key_record.id,
          data: {
            values: {
              ...key_record.values,
              [this.$store.state.integration.metrics_mapping.contact_relationship_strength_metric]: i
            }
          }
        })
        .then(() => {
          this.$emitter.emit(ALL_EMITTERS.UPDATE_KEY_RECORDS_TIED_RECORD)
        })
    },
    deleteKeyRecord(record) {
      this.key_records = this.key_records.filter((r) => r.id !== record.id)
    },
    addKeyPeople() {
      this.key_records = this.key_records.concat(this.selected_contacts)
      this.add_new_key_record = false
      this.selected_contacts = []
    },
    saveChanges() {
      this.$store
        .dispatch("data/updateRecord", {
          record_id: this.record.id,
          data: { key_records: this.key_records.map((r) => r.id) }
        })
        .then((res) => {
          this.$emitter.emit(ALL_EMITTERS.UPDATE_KEY_RECORDS_TIED_RECORD)
          this.$store.dispatch("ui/setCurrentCompany", res.data)
          this.$emit("done")
        })
    }
  }
}
</script>
